// import resume from '../assets/pdf/resume.pdf';
import avatarPhoto from '../assets/png/20230205_123332.jpg';

export const headerData = {
  name: 'Amin Deraiya',
  title: 'React Developer',
  desciption:
    'Technology has the power to change the world. I strive to be a part of that change, every day.',
  image: avatarPhoto,
  resumePdf: '',
};
